import React, { memo } from "react";
import { GamePreviewDTO } from "../../../types/Game";
import { TicketRequestDTO } from "../../../types/TicketRequest";
import AdminRequestGame from "./AdminRequestGame";

type AdminRequestsViewProps = {
  schedule: number[];
  games: { [key: number]: GamePreviewDTO };
  requests: { [key: number]: TicketRequestDTO[] };
  startDate: string;
  jumpToRequestId?: number;
};

const AdminRequestsView = memo(({ schedule = [], games, requests, jumpToRequestId }: AdminRequestsViewProps) => {
  return (
    <>
      {schedule.map((gamePk: number) => {
        const game = games[gamePk];

        return (
          <AdminRequestGame key={gamePk} game={game} requests={requests[gamePk]} jumpToRequestId={jumpToRequestId} />
        );
      })}
    </>
  );
});

export default AdminRequestsView;
